// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__iF_Xi","content":"GlobalSearch_content__4Hv59"};